import {
    URLAPI,
    OPERATOR_PATH,
    OPERATOR_CREATE_PATH,
    OPERATOR_UPDATE_PATH,
    OPERATOR_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_operator: {
        data: [],

        status: 0,
        message: {},
    },

    _create_operator: {
        data: {},
        status: 0,
        message: {},
    },
    _update_operator: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_operator: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_OPERATOR = "GET_ALL_OPERATOR";
export const CREATE_OPERATOR = "CREATE_OPERATOR";
export const UPDATE_OPERATOR = "UPDATE_OPERATOR";
export const DELETE_OPERATOR = "DELETE_OPERATOR";

export const operator_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_OPERATOR:
            return {
                ...state,
                _get_all_operator: action.payload,
            };
        case CREATE_OPERATOR:
            return {
                ...state,
                _create_operator: action.payload,
            };
        case UPDATE_OPERATOR:
            return {
                ...state,
                _update_operator: action.payload,
            };
        case DELETE_OPERATOR:
            return {
                ...state,
                _delete_operator: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllOperator = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${OPERATOR_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_OPERATOR,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_OPERATOR,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_OPERATOR,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

//create operator
export const createOperator = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${OPERATOR_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_OPERATOR,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_OPERATOR,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_OPERATOR,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateOperator = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${OPERATOR_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_OPERATOR,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_OPERATOR,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_OPERATOR,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteOperator = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${OPERATOR_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_OPERATOR,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_OPERATOR,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_OPERATOR,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_operator = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
